import { RemaxGlobalAdapter } from "@/src-refactor/modules/shared/helpers/remax-global.adapter";
import { IPropertyDetailsResponse } from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-details.response";
import { RemaxGlobalStatusSync } from "@rf-l1/page/details/card-remax-global/MxDetailCardAgent";

export const prepareDetailPropertyRemaxGlobal = (
  data: IPropertyDetailsResponse
): RemaxGlobalStatusSync => {
  return RemaxGlobalAdapter({
    sync_status: data?.sync_status,
    sync_error_message: data?.sync_error_message
  });
};
